/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_6_DescInputs */

const en_mk_loop_6_desc = /** @type {(inputs: Mk_Loop_6_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You approve the phase, or return tasks to the agent with a note. Then up to 4 tasks with non-overlapping files run in parallel.`)
};

const id_mk_loop_6_desc = /** @type {(inputs: Mk_Loop_6_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamu setujui fase, atau kembalikan task ke agent dengan catatan. Lalu sampai 4 task tanpa file tumpang tindih berjalan paralel.`)
};

/**
* | output |
* | --- |
* | "You approve the phase, or return tasks to the agent with a note. Then up to 4 tasks with non-overlapping files run in parallel." |
*
* @param {Mk_Loop_6_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_6_desc = /** @type {((inputs?: Mk_Loop_6_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_6_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_6_desc(inputs)
	return en_mk_loop_6_desc(inputs)
});